import { render, staticRenderFns } from "./RegisterAdjustment.vue?vue&type=template&id=84277222&scoped=true&"
import script from "./RegisterAdjustment.vue?vue&type=script&lang=ts&"
export * from "./RegisterAdjustment.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterAdjustment.vue?vue&type=style&index=0&id=84277222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84277222",
  null
  
)

export default component.exports